module.exports = __webpack_public_path__ + "img/banner.969f0d8e.png";